import helpers from 'src/helpers'
export default {
  iTokenVoucherList: state => {
    return state.voucherList
  },
  iTokenCampaignList: state => {
    return state.campaignList
  },
  iTokenCampaignOptions: state => {
    return state.campaignList.list.data.map(opt => ({
      label: opt.name,
      value: opt.id,
      is_active: opt.is_active,
    }))
  },
  iTokenAccumulateCalculationList: state => {
    return state.accumulateCalculationList
  },
  iTokenCampaignData: state => {
    return state.campaign.data
  },
  iTokenRedemptionList: state => {
    return state.redemptionList
  },
  iTokenRedemptionData: state => {
    return state.redemption.data
  },
  iTokenVoucherListOptions: state => {
    let data = state.voucherList.list.data || []
    return data.map(x => {
      return {
        label: x.voucher_no,
        sublabel: x.campaign.name,
        value: x.id,
        items: helpers.getValue(x, 'campaign.items', []),
        voucher_point: x.voucher_point,
      }
    })
  },
}
